import {Observable, SchedulerLike, timer} from 'rxjs';
import {mapTo, switchMap, takeUntil} from 'rxjs/operators';

/**
 * RxJs pipeable operator.
 * Extended version of the debounceTime operator with ability to cancel the delayed event.
 * @param {number} dueTime
 * @param {Observable<*>} cancellationNotifier
 * @param {SchedulerLike} scheduler
 * @returns {(source: Observable<T>) => Observable<T>}
 */
export const cancellableDebounceTime = <T>(
    dueTime: number,
    cancellationNotifier: Observable<any>,
    scheduler?: SchedulerLike
) => (source: Observable<T>): Observable<T> => source.pipe(
    switchMap(lastValue =>
        timer(dueTime, scheduler).pipe(
            mapTo(lastValue),
            takeUntil(cancellationNotifier)
        )
    )
);
